import { Stack, Button, Dialog, Typography, DialogContent, DialogTitle } from '@mui/material';
import * as React from 'react';
import TargetEditor from './TargetEditor';
import * as Utils from '../util/Utils';
import * as ATCAConstants from '../util/ATCAConstants'

export default function NewTargetDialog(
  props: {
    addTarget: (scan: any) => void,
    message: string,
    open: boolean,
    handleClose: () => void
}) {

  const [target, setTarget] = React.useState<any>(ATCAConstants.INIT_TARGET);
  const [isTargetValid, setIsTargetValid] = React.useState(false);

  const addTarget = () => {
    if (!target['name']) {
      if ((target['coord_sys']||'J2000') === 'J2000') {
        const ra = target['ra']||'';
        const dec = target['dec']||'';
        // generate a name
        let name = 'J';
        const ras = ra.split(':');
        const decs = dec.split(':');

        if ((ras.length>2) && (decs.length>2)) {
          name += ras[0] + ras[1];
          if (decs[0].startsWith('-') || decs[0].startsWith('+')) {
            name += decs[0];
          } else {
            name += '+' + decs[0];
          }

          name += decs[1];
          target['name'] = name;
        }
      }
    }

    props.addTarget(target);
  }

  React.useEffect(() => {
    if (!props.open) {
      setTarget(ATCAConstants.INIT_TARGET);
    }
  }, [props.open]);

  React.useEffect(() => {
    const newIsValid = Utils.validateTarget(target);
    setIsTargetValid(newIsValid['isValid']);
  }, [target]);

  return (
    <Dialog open={props.open} maxWidth="sm" fullWidth
      aria-labelledby="new-target-dialog-title"
      onClose={props.handleClose}>
        
      <DialogTitle id="new-target-dialog-title">
        Add New Target
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <TargetEditor showCalibrator={false} target={target} setTarget={setTarget}/>
            <Button 
              disabled={!isTargetValid}
              variant="outlined" onClick={addTarget}>
              Add
            </Button>
            <Typography variant="caption" >
              {props.message}
            </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}